<script>
import { merchantComputed } from '@state/helpers'
export default {
  data() {
    return {
      submitData: {
        isEnabled: false, // 是否開放顧客預約前台狀態
        title: '', // 選單名稱
        terms: '', // 契約內容
      },
      storeStatus: false, // 儲存Loading 狀態
    }
  },
  computed: {
    ...merchantComputed,
    submitRules() {
      return {
        title: [
          {
            required: true,
            message: '請填寫選單名稱',
            trigger: 'blur',
          },
        ],
      }
    },
    fromatPrapaidTerms() {
      return `${this.currentMerchant.name || '店家'}美容服務注意事項

${this.currentMerchant.name || '店家'}（後稱「本店」）提供「寵物美容服務」（後稱「本服務」），以下為本服務使用規則說明：

一. 飼主應針對寵物身體狀況盡告知義務，若因隱瞞病況發生意外或死亡，經法定程序判定店家無疏失，本店無須負損害賠償責任。
二. 飼主應於美容當日將寵物領回，如經通知1日內未領回，依動保法第29條第一款通知主管機關，為飼主惡意棄養，相關罰金為3萬～15萬元，其他衍生性費用將跟飼主求償，例：人員加班費等。
三. 寵物發生攻擊行為，如因飼主未善盡告知義務而造成店內人員傷亡、財物損毀等費用，將全額向飼主（寵物占有權人）求償。
四. 店家應按本契約約定內容提供一定品質之美容服務。若因可歸責於店家或其受雇人之事由，導致其提供之美容服務有瑕玼，造成飼主發生損失的情況，飼主得要求減少價金或減除契約。
五. 本契約之任一方得隨時終止本契約，若因本契約之終止而生損害之一方得向他方請求賠償。
六. 於美容服務期間，如發現寵物有異常狀態，應立即通知飼主並妥善處理，如發生異常狀態的原因可歸貴店家之操作行為，店家應負損害賠償的責任，例：摔傷寵物等。
七. 除本合約另有約定、特殊緊急情況，或不可抗力之情況外，未經飼主同意，本店不得將寵物帶離美容場所（同上店家地址）、轉售、轉讓或以其他變相方法作為其他用途。
八. 本合約之任何條款或部分如因任何理由被認定為無效或無法執行者，其無效或無法執行以該條款或部分為限，不影響其他條款或該條款其他部分之有效性。
九. 本合約之準據法為中華民國法律。因本合約涉訟時，雙方同意以司法院公告本店所屬轄區之地方法院為第一審管轄法院。
`
    },
  },
  async created() {},
  async mounted() {
    await this.getGoodsService()
  },
  methods: {
    /**
     * @description 取消編輯
     */
    onClickLeave() {},
    /**
     * @description 基本設定 -> 取得商品管理基本設定
     */
    async getGoodsService() {
      try {
        const { response } = await this.$store.dispatch('merchant/getCosmeticBasicSet', {
          type: 'goods',
        })
        this.submitData = response.items
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 基本設定 -> 儲存美容服務
     */
    async tryToStore() {
      try {
        await this.$refs.form.validate()
        this.storeStatus = true
        const { response } = await this.$store.dispatch('merchant/postCosmeticBasicSet', {
          type: 'goods',
          payload: this.submitData,
        })
        if (response.code === 200) {
          this.$message({
            message: '儲存成功！',
            type: 'success',
          })
          await this.getGoodsService()
        }
      } catch (error) {
        console.error(error.message)
      } finally {
        this.storeStatus = false
      }
    },
  },
}
</script>
<template>
  <div :class="$style.basicSetForm">
    <el-form ref="form" :model="submitData" label-position="top" :rules="submitRules">
      <div :class="$style.title">
        <h4 data-tour-text="" class="form-block-title justify-content-start fs-lg"
          ><span class="isStyleRequired">選單名稱</span> <span class="ml-3 text-danger text-secondary fs-sm">此名稱會顯示在前台</span></h4
        >
      </div>
      <el-row :class="$style['basicSetForm_titleHeight']">
        <el-form-item label="" prop="title" style="margin-bottom: 0">
          <el-input v-model="submitData.title" :md="24" placeholder="商品管理" class="bg-white is-border"> </el-input>
        </el-form-item>
      </el-row>
      <el-divider></el-divider>
      <!-- 尚未開放前台購買功能 -->
      <!-- <el-row :gutter="20" type="flex" justify="space-between" :class="$style['basicSetForm_rowHeight']">
        <el-col :span="19">
          <h3 :class="$style.fontSize">是否開放前台購買商品</h3>
        </el-col>
        <el-col :span="5">
          <el-switch v-model="submitData.isEnabled" active-text="是" inactive-text="否" :active-value="1"
            :inactive-value="0"></el-switch>
        </el-col>
      </el-row> -->

      <!-- <el-divider></el-divider> -->
      <h4 class="form-block-title" :class="$style.fontSize">商品定型化契約</h4>
      <el-row :gutter="20" type="flex" justify="space-between" :class="$style['basicSetForm_inputContract']">
        <el-form-item label="" prop="terms" class="mb-0 w-100">
          <div>
            <span :class="$style.label" class="text-secondary">
              契約內容
            </span>
            <!-- <el-button class="is-round mb-3" @click="setDefaultContact">引用系統提供的商品定型化契約</el-button> -->
          </div>
          <el-input v-model="submitData.term" type="textarea" :autosize="{ minRows: 7 }" class="bg-white is-round is-border" />
        </el-form-item>
      </el-row>
    </el-form>
    <div :class="$style.footer">
      <el-button class="is-round" @click="onClickLeave">取消編輯</el-button>
      <el-button :loading="storeStatus" class="is-round" type="primary" @click="tryToStore">儲存編輯</el-button>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

.title {
  display: flex;
  justify-content: start;
  align-items: center;

  > h4 {
    margin-top: 0;
    margin-bottom: 0;
  }
}

.fontSize {
  font-size: 16px;
}

.basicSetForm {
  :global {
    overflow: scroll;
    width: 100%;
    background-color: white;
    padding: 18px 20px 100px;
  }

  &_titleHeight {
    margin-bottom: 24px;
    margin-top: 12px;
  }

  &_rowHeight {
    height: 66px;
    display: flex;
    flex-direction: row;
    align-items: center;

    :global {
      .el-switch {
        width: 150px;
      }

      .el-switch__label {
        width: 32.5px;
        text-align: center;
      }
    }
  }

  &_inputPart {
    flex-direction: column;
    margin-bottom: 17px;

    &_slider {
      padding-left: 10px;
    }
  }

  &_inputContract {
    margin-top: 12px;
    padding-left: 10px;
    padding-right: 10px;

    > div {
      margin-bottom: 10px;

      .label {
        padding-right: 10px;

        &:after {
          content: ' *';
          color: red;
        }
      }
    }

    > el-input {
      height: 176px;
    }
  }
}

:global {
  .el-col-5 {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
